import { useMemo, useState } from 'react';

import { useEdgeComputeConfigured } from '@/react/edge/useEdgeComputeConfigured';

import { useWizardSteps } from '@@/Stepper/useWizardSteps';
import { PageHeader } from '@@/PageHeader';
import { TextTip } from '@@/Tip/TextTip';
import { Widget, WidgetBody, Loading } from '@@/Widget';
import { Link } from '@@/Link';

import {
  WizardStep,
  WizardProvider,
  WizardMode,
} from '../wizard/WizardContext';
import { buildWizardSteps } from '../wizard/buildWizardSteps';

import { CreateForm } from './CreateForm';

export function CreateView() {
  return (
    <div className="form-horizontal pb-20">
      <PageHeader
        title="Create Workflow"
        breadcrumbs={[
          { link: '.^', label: 'GitOps Workflows' },
          { label: 'Create Workflow' },
        ]}
      />

      <div className="row">
        <div className="col-sm-12">
          <CreateViewContent />
        </div>
      </div>
    </div>
  );
}

function CreateViewContent() {
  const [artifactCount, setArtifactCount] = useState(1);
  const steps = useMemo(() => buildWizardSteps(artifactCount), [artifactCount]);
  const context = useWizardSteps<WizardStep>({ steps });
  const edgeComputeConfiguredQuery = useEdgeComputeConfigured();

  if (edgeComputeConfiguredQuery.isLoading) {
    return <Loading />;
  }

  if (!edgeComputeConfiguredQuery.isSuccess) {
    return null;
  }

  if (!edgeComputeConfiguredQuery.data) {
    return <EdgeComputeDisabledNotice />;
  }

  return (
    <WizardProvider
      context={{
        ...context,
        mode: WizardMode.Create,
        artifactCount,
        setArtifactCount,
      }}
    >
      <CreateForm steps={steps} />
    </WizardProvider>
  );
}

function EdgeComputeDisabledNotice() {
  return (
    <Widget>
      <WidgetBody>
        <TextTip color="orange">
          Workflows deploy to Edge groups, so Edge Compute features must be
          enabled to create one. Turn them on{' '}
          <Link
            to="portainer.settings.edgeCompute"
            data-cy="workflow-create-edge-disabled-settings-link"
          >
            here
          </Link>{' '}
          and have the Portainer API server URL and tunnel server address
          properly configured.
        </TextTip>
      </WidgetBody>
    </Widget>
  );
}
